import * as React from 'react';

const RadioChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <circle cx={12} cy={12} r={10} />
        <circle cx={12} cy={12} r={9} fill="#fff" />
        <circle cx={12} cy={12} r={4} />
    </svg>
);

RadioChunkySvg.displayName = 'RadioChunkySvg';
export default RadioChunkySvg;
